import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

/**
 * Server-side, cookieless page-view tracker.
 * Fires a POST /api/track on every React Router pathname change.
 * Skips /admin (so the admin browsing the dashboard doesn't pollute stats).
 * De-duplicates the very first mount + a duplicate fire within 1s
 * (StrictMode runs effects twice in dev).
 */
export default function PageViewTracker() {
  const { pathname } = useLocation();
  const last = useRef({ path: null, at: 0 });

  useEffect(() => {
    if (!pathname) return;
    // Skip admin browsing
    if (pathname.startsWith("/admin")) return;

    const now = Date.now();
    if (last.current.path === pathname && now - last.current.at < 1500) return;
    last.current = { path: pathname, at: now };

    const payload = {
      path: pathname,
      referer: document.referrer || "",
      screen: `${window.innerWidth}x${window.innerHeight}`,
    };

    // Fire-and-forget — failures must never break the UX
    api.post("/track", payload).catch(() => {});
  }, [pathname]);

  return null;
}
